export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_COLDWARM = 'USER_COLDWARM'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const DETECT_LANGUAGE = 'DETECT_LANGUAGE'



// WEBPACK FOOTER //
// ./src/store/actions/user.js